import React, { ReactNode } from "react";

const getColorStroke = (value: number): string => {
  if (value <= 25) return "stroke-red-500";
  if (value <= 50) return "stroke-red-500";
  if (value <= 80) return "stroke-primaryBlue";
  return "stroke-green-500";
};

type Props = {
  score: number;
  strokeWidth?: number;
  size?: number;
  useDefaultLable?: boolean;
  label?: string;
  className?: string;
  children?: ReactNode;
};

export default function ProgressAlertCircular({
  score = 0,
  strokeWidth = 2.8,
  size = 50,
  useDefaultLable = true,
  label,
  className,
  children,
}: Props) {
  const radius = size / 2;
  const normalizedRadius = radius - strokeWidth;
  const circumference = 2 * Math.PI * normalizedRadius;

  const strokeDashoffset = circumference - (score / 100) * circumference;

  const strokeColorClass = getColorStroke(score);

  return (
    <div
      className="relative shrink-0 flex items-center justify-center"
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <svg height={radius * 2} width={radius * 2} className="-rotate-90">
        <circle
          stroke="#e5e7eb"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />

        <circle
          className={`${strokeColorClass} transition-all duration-500`}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset }}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      {/* Center Text */}
      {useDefaultLable && !children && (
        <div className="absolute flex flex-col items-center font-bold uppercase text-primaryBlack">
          <span className={className ? className : "text-xs"}>{label ?? score}</span>
        </div>
      )}

      {children && (
        <div className={`absolute ${className ? className : "flex flex-col items-center font-bold uppercase"}`}>
          {children}
        </div>
      )}
    </div>
  );
}
